import OwlCarousel from "react-owl-carousel";
export const WatchoViewList = () => {
    return(
        <div className="watchoViewList">
            <OwlCarousel
            className="owl-theme"
            items={3}
            margin={20}
            nav={false}
            loop={true}
            dots={false}
            autoplay={true}
            stagePadding={100}
            slideBy={1}
            autoplayTimeout={3000}
            autoplaySpeed={500}
            autoplayHoverPause={true}
            responsive={{
                0: {
                    items: 1
                },
                768: {
                    items: 2
                },
                1024: {
                    items: 3
                }
            }}
            >
            <div>
                <img src="../Images/WatchoDownloadLP/movies/banner1.png" />
            </div>
            <div>
                <img src="../Images/WatchoDownloadLP/movies/banner2.png" />
            </div>
            <div>
                <img src="../Images/WatchoDownloadLP/movies/banner3.png" />
            </div>
            <div>
                <img src="../Images/WatchoDownloadLP/movies/banner1.png" />
            </div>
            <div>
                <img src="../Images/WatchoDownloadLP/movies/banner2.png" />
            </div>
            <div>
                <img src="../Images/WatchoDownloadLP/movies/banner3.png" />
            </div>
          </OwlCarousel>
        </div>
    )
}